export default __webpack_public_path__ + "static/media/delete_file_btn.e4bf4b97.svg";